import { ErrorHandler, Provider } from '@angular/core';

export const provideErrorHandler = (
    errorHandler?: typeof ErrorHandler,
): Provider => ({
    provide: ErrorHandler,
    useClass: errorHandler,
});
